import { error, warn } from './error';

export const logger = {
  error,
  warn,
} as const;
